import { ArticleLieuDepart } from '@/model/article-lieu-depart';
import Axios from 'axios';
import { ApiUtils } from './api-utils';

export class ArticlesLieuxDepartApi {
  static getArticlesLieuxDepart (): Promise<ArticleLieuDepart[]> {
    return ApiUtils.responseParser(Axios.get('/web/v1/articles-lieux-depart'), [ArticleLieuDepart]);
  }
}
